import {apiClient} from 'app/components/shared';
import {PayAsYouGoBillingContracts} from 'app/components/entities/billing/payasyougo';

export class PayAsYouGoBillingApi {
  static async getHistory(teamId: string): Promise<PayAsYouGoBillingContracts.History> {
    return apiClient.get(`/front/api/v1t/team/${teamId}/billing/v2/pay-as-you-go/invoice/history`);
  }
}
